import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import APIRoutes from 'api/routes'
import axios from 'axios'
import { useEffect } from 'react'

export default function ApproveShare() {
  const { shareapproveid } = useParams()
  const [NoApprove, SetNoApprove] = useState(false)
  const [approve, setApprove] = useState(false)
  useEffect(() => {
    const url = process.env['REACT_APP_VAULT_API_URL']
    axios
      .post(`${url}${APIRoutes.vaultAprroveDeclineBoShare}`, {
        requestId: shareapproveid,
        status: 'A',
      })
      .then(res => {
        if (res.data.response_status === 200) {
          setApprove(true)
          SetNoApprove(false)
        } else {
          return null
        }
      })
      .catch(err => {
        SetNoApprove(true)
        setApprove(false)
      })
  }, [shareapproveid])

  return (
    <>
      {approve && (
        <div className="container" style={{ textAlign: 'center', color: '#25245f', marginTop: '40px' }}>
          <div className="row justify-content-md-left">
            <div>
              <img
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                height={40}
                alt="logo"
              />
            </div>
            <div style={{ marginTop: '30px' }}>
              <h1>
                <b>Thank you !</b>
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center text-center">
            <div className="col p-5 m-5">
              <h3>
                We will alert the user that you have Approved the request to share the beneficial ownership information.
                You may close this window.
              </h3>
            </div>
          </div>
        </div>
      )}
      {NoApprove && (
        <div className="container" style={{ textAlign: 'center', color: '#25245f', marginTop: '40px' }}>
          <div className="row justify-content-md-left">
            <div>
              <img
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                height={40}
                alt="logo"
              />
            </div>
            <div style={{ marginTop: '30px' }}>
              <h1>
                <b>Thank you !</b>
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center text-center">
            <div className="col p-5 m-5">
              <h3>Your response has already beeen recorded</h3>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export function DeclineShare() {
  const { sharedeclineid } = useParams()
  const [NoDecline, SetNoDecline] = useState(false)
  const [decline, setDecline] = useState(false)
  useEffect(() => {
    const url = process.env['REACT_APP_VAULT_API_URL']
    axios
      .post(`${url}${APIRoutes.vaultAprroveDeclineBoShare}`, {
        requestId: sharedeclineid,
        status: 'D',
      })
      .then(res => {
        if (res.data.response_status === 200) {
          setDecline(true)
          SetNoDecline(false)
        } else {
          return null
        }
      })
      .catch(err => {
        SetNoDecline(true)
        setDecline(false)
      })
  }, [sharedeclineid])

  return (
    <>
      {decline && (
        <div className="container" style={{ textAlign: 'center', color: '#25245f', marginTop: '40px' }}>
          <div className="row justify-content-md-left">
            <div>
              <img
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                height={40}
                alt="logo"
              />
            </div>
            <div style={{ marginTop: '30px' }}>
              <h1>
                <b>Thank you !</b>
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center text-center">
            <div className="col p-5 m-5">
              <h3>
                We will alert the user that you have Declined the request to share the beneficial ownership information.
                You may close this window.
              </h3>
            </div>
          </div>
        </div>
      )}
      {NoDecline && (
        <div className="container" style={{ textAlign: 'center', color: '#25245f', marginTop: '40px' }}>
          <div className="row justify-content-md-left">
            <div>
              <img
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                height={40}
                alt="logo"
              />
            </div>
            <div style={{ marginTop: '30px' }}>
              <h1>
                <b>Thank you !</b>
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center text-center">
            <div className="col p-5 m-5">
              <h3>Your response has already beeen recorded</h3>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
